import * as _actions from './actions';
import _reducer from './reducer';
import _StudentTasks from './model';
import create from './create';
import * as _accessors from './accessors';

_StudentTasks.actions = _actions;
_StudentTasks.create = create;

export const actions = _actions;
export const reducer = _reducer;
export const accessors = _accessors;
export const StudentTasks = _StudentTasks;



// WEBPACK FOOTER //
// ./data/StudentTasks/index.js